// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".vld-overlay,.vld-shown{overflow:hidden}.vld-overlay{align-items:center;bottom:0;display:none;justify-content:center;left:0;position:absolute;right:0;top:0;z-index:9999}.vld-overlay.is-active{display:flex}.vld-overlay.is-full-page{position:fixed;z-index:9999}.vld-overlay .vld-background{background:#fff;bottom:0;left:0;opacity:.5;position:absolute;right:0;top:0}.vld-overlay .vld-icon,.vld-parent{position:relative}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
